import { Outlet, redirect, RouteObject } from 'react-router-dom';

import { AuthRoot } from '@/shared/app/auth/auth-root';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';

export const authRoutes: RouteObject = {
  path: '/auth',
  hydrateFallbackElement: <FullscreenLoader />,
  element: <AuthRoot />,
  children: [
    {
      index: true,
      loader: () => {
        return redirect('login');
      },
    },
    {
      path: 'login',
      lazy: async () => {
        const { LoginRoute } = await import('./login');
        return { Component: LoginRoute };
      },
    },
    {
      path: 'reset-password',
      Component: () => <Outlet />,
      children: [
        {
          index: true,
          lazy: async () => {
            const { ResetPasswordRoute } = await import('./reset-password');
            return { Component: ResetPasswordRoute };
          },
        },
        {
          path: 'confirm',
          lazy: async () => {
            const { ResetPasswordConfirmRoute } =
              await import('./reset-password-confirm');
            return { Component: ResetPasswordConfirmRoute };
          },
        },
      ],
    },
    {
      path: 'mfa',
      lazy: async () => {
        const { MfaRoute } = await import('./mfa');
        return { Component: MfaRoute };
      },
    },
    {
      path: 'create-new-password',
      lazy: async () => {
        const { CreateNewPasswordRoute } =
          await import('./create-new-password');
        return { Component: CreateNewPasswordRoute };
      },
    },
  ],
};
